import { render, staticRenderFns } from "./DailyTasks.vue?vue&type=template&id=0812277b"
import script from "./DailyTasks.vue?vue&type=script&lang=js"
export * from "./DailyTasks.vue?vue&type=script&lang=js"
import style0 from "./DailyTasks.vue?vue&type=style&index=0&id=0812277b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports